PageApp.Ent.ItemAlerts = Backbone.Collection.extend({
  model: PageApp.Ent.ItemAlert,
  initialize: function (models, options) {
    this.url = myApp.ent.config.get('contextPath') + '/itemalerts'
  }
})
